<template>
  <div class="quarter_report_basic_con">
    <Frame title="2022年年度报告">
      <template slot="contentSlot">
        <div class="quarter_report_wrapper">
          <div id="technolog_chart"></div>
          <div class="ability_wrapper">
            <div class="ability">
              <el-image
                class="border_line"
                src="/img/factoring/border_line_r.svg"
              ></el-image>
              <div class="ability_title">
                <el-image
                  class="ability_icon"
                  src="/img/factoring/cznl.png"
                ></el-image>
                偿债能力
              </div>
              <div class="ability_con">
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">资产负债率</div>
                    <div class="label_val">0</div>
                  </div>
                  <div class="label">
                    <div class="ab_label_name">资产负债率</div>
                    <div class="label_val">0</div>
                  </div>
                </div>
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">流动比率</div>
                    <div class="label_val">0</div>
                  </div>
                  <div class="label">
                    <div class="ab_label_name">现金比率</div>
                    <div class="label_val">0</div>
                  </div>
                </div>
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">速冻比率</div>
                    <div class="label_val">0</div>
                  </div>
                  <div class="label">
                    <div class="ab_label_name">现金流量比率</div>
                    <div class="label_val">0</div>
                  </div>
                </div>
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">利息保障倍数</div>
                    <div class="label_val">0</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ability">
              <el-image
                class="border_line"
                src="/img/factoring/border_line_r.svg"
              ></el-image>
              <div class="ability_title">
                <el-image
                  class="ability_icon"
                  src="/img/factoring/ylnl.png"
                ></el-image>
                盈利能力
              </div>
              <div class="ability_con">
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">
                      总资产收益率 <span>(ROA)</span>
                    </div>
                    <div class="label_val">0</div>
                  </div>
                  <div class="label">
                    <div class="ab_label_name">净资产收益率<span>(ROE)</span></div>
                    <div class="label_val">0</div>
                  </div>
                </div>
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">销售毛利率</div>
                    <div class="label_val">0</div>
                  </div>
                  <div class="label">
                    <div class="ab_label_name">盈余现金保障倍数</div>
                    <div class="label_val">0</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ability">
              <el-image
                class="border_line"
                src="/img/factoring/border_line_r.svg"
              ></el-image>
              <div class="ability_title">
                <el-image
                  class="ability_icon"
                  src="/img/factoring/yynl.png"
                ></el-image>
                营运能力
              </div>
              <div class="ability_con">
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">存货周转率</div>
                    <div class="label_val">0</div>
                  </div>
                  <div class="label">
                    <div class="ab_label_name">
                      应收账款周转率<span>(次)</span>
                    </div>
                    <div class="label_val">0</div>
                  </div>
                </div>
                <div class="ability_con_flex">
                  <div class="label">
                    <div class="ab_label_name">总资产周转率</div>
                    <div class="label_val">0</div>
                  </div>
                  <div class="label">
                    <div class="ab_label_name">流动资产周转率</div>
                    <div class="label_val">0</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <el-image
            class="border_line"
            src="/img/factoring/border_line_r.svg"
          ></el-image> -->
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "@/views/factoring/customerManage/components/frame.vue";
import * as echarts from "echarts";
import "echarts-liquidfill";

import "@/util/echarts-auto-tooltip";
export default {
  name: "quarterReport",
  components: {
    Frame,
  },
  data() {
    return {
      pieDate: 0,
      chart: null,
      tootipTimer: null,
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.tootipTimer.clearLoop();
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById("technolog_chart"));

      window.onresize = () => {
        this.chart.resize();
      };
      this.$nextTick(() => {
        this.setOptions();
      });
    },

    setOptions() {
      let chartdata = [this.pieDate, this.pieDate, this.pieDate, this.pieDate];
      let _this = this;

      let option = {
        title: {
          text: (_this.pieDate * 100).toFixed(0) + "%",
          textStyle: {
            fontSize: 28,
            // fontFamily: "youshe",
            fontWeight: "700",
            color: "#5781B3",
            rich: {
              a: {
                fontSize: 25,
              },
            },
          },
          x: "center",
          top: "30%",
        },
        graphic: [
          {
            type: "group",
            left: "center",
            top: "60%",
            children: [
              {
                type: "text",
                z: 100,
                left: "0",
                top: "middle",
                style: {
                  fill: "#5781B3",
                  text: "权益净利率",
                  fontSize: 14,
                },
              },
            ],
          },
        ],
        series: [
          {
            type: "liquidFill",
            radius: "88%",
            center: ["50%", "50%"],
            data: [0.5],

            backgroundStyle: {
              color: "white",
              borderColor: "#18C8CC",
              borderWidth: 1,
            },
            itemStyle: {
              opacity: 0.5,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 1,
                    color: "#09ABCC",
                  },
                  {
                    offset: 0.8,
                    color: "#17C7CC",
                  },
                  {
                    offset: 0,
                    color: "#2CF1CC",
                  },
                ],
                globalCoord: false,
              },
            },
            label: {
              normal: {
                formatter: "",
              },
            },
            outline: {
              show: false,
            },
          },
        ],
      };

      this.tootipTimer =
        // = autoHover(this.chart, option, 3, 3000);
        tools.loopShowTooltip(this.chart, option, {
          loopSeries: true,
        });
      this.chart.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
$base_width: 1920;
$base_height: 1080;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
@function vh($px) {
  @return ($px / $base_height) * 100vh;
}
@font-face {
  font-family: youshe;
  src: url("/img/screen/youshe.ttf");
}
.quarter_report_basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  height: 300px;
}

.quarter_report_wrapper {
  display: flex;
  align-items: center;
  // justify-content: space-around;
  #technolog_chart {
    width: 152px;
    height: 152px;
    padding-right: vw(20);
  }
  .ability_wrapper {
    flex: 1;
    display: flex;
    .ability {
      position: relative;
      font-size: 14px;
      color: #333333;
      flex: 1;
      padding: 0 vw(20);
      .border_line {
        position: absolute;
        width: 2px;
        height: 181px;
        left: 0;
      }
      .ability_title {
        display: flex;
        align-items: center;
        .ability_icon {
          width: 12px;
          height: 12px;
          margin-right: 2px;
        }
      }
      .ability_con {
        padding-top: 20px;
        .ability_con_flex {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .label {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 50%;
            .ab_label_name {
              display: flex;
              flex-direction: column;
              font-size: 11px;
              color: rgba(102, 102, 102, 0.8);
              text-align: left;
              line-height: 28px;
              flex: 1;
            }
            .label_val {
              font-weight: 400;
              font-style: normal;
              font-size: 11px;
              text-align: left;
              color: #333;
              margin-right: vw(20);
            }
          }
        }
      }
    }
  }
}
</style>

 